
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5vSwz", function(module, exports) {

$parcel$export(module.exports, "DateComponent", () => $85a675280bdd34e2$export$19285a5b05c4ea7c);
/* DateComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $gdv5Z = parcelRequire("gdv5Z");
const $85a675280bdd34e2$var$styles = {
    dateWrapper: "_2rkogqwt _1h6d3acm"
};
const $85a675280bdd34e2$export$19285a5b05c4ea7c = ({ timestamp: timestamp })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        as: "span",
        backgroundColor: "color.background.neutral",
        padding: "space.025",
        testId: "data-component",
        xcss: $85a675280bdd34e2$var$styles.dateWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2nPZH.FormattedDate), {
        value: new Date(parseInt(timestamp)).toLocaleString('en-US', {
            timeZone: 'Australia/Sydney'
        }),
        year: "numeric",
        month: "short",
        day: "numeric"
    }));
};

});


//# sourceMappingURL=DateComponent.a9406692.js.map
